import styled, { css } from 'styled-components';
import { getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import BaseItem from '../Item';
const byType = {
  text: css`
    font-size: ${props => themeGet('fontSizes.1')(props)}px;
    line-height: ${props => themeGet('lineHeights.plus')(props)}px;
    color: ${props => getTextColor('scratched')(props)};

    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    ${props => props.open ? css`
            max-height: 54px;
            margin-bottom: 16px;
          ` : css`
            max-height: 0px;
          `}
  `,
  component: css`
    max-height: ${props => props.open ? '100%' : '0px'};
  `
};
export const Container = styled(BaseItem).attrs(props => Object.assign({
  cursor: 'pointer',
  outline: 'none',
  py: 0,
  gap: 0
}, props))``;
export const Header = styled(Container.Header)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding-right: 8px;
`;
export const Content = styled(Container.Content)`
  overflow: hidden;
  transition: max-height 0.3s ease-out;

  ${props => props.isText ? byType.text : byType.component}
`;
export const IconsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30px, max-content));
  justify-content: center;
  padding: 8px;
  grid-gap: ${props => themeGet('space.4')(props)}px;
`;